import React, { useEffect, useState } from "react";
import {
  ActionQueueItemKey,
  onTriggerActionQueueItem,
} from "src/helpers/actionQueueHelpers";

export interface ITestFormData {
  chosenColor: string;
  reason: string;
}

const ActionQueue: React.FC = () => {
  const [formVals, setFormVals] = useState<ITestFormData>({
    chosenColor: "Red",
    reason: "",
  });

  const setChosenColor = (chosenColor: string) =>
    setFormVals({
      ...formVals,
      chosenColor,
    });

  const setReason = (reason: string) =>
    setFormVals({
      ...formVals,
      reason,
    });

  useEffect(() => {
    window.addEventListener("message", (event) => {
      try {
        const queueItem = JSON.parse(event?.data);

        onTriggerActionQueueItem(queueItem, alert);
      } catch (e) {
        console.error(event?.data);
      }
    });
  }, []);

  return (
    <div style={{ textAlign: "left", padding: 50 }}>
      <div>Action Queue POC</div>
      <br />
      <div>
        Select a value in dropdown, then type anything in the input field.
      </div>
      <div>Click Send to simulate sending of value to API.</div>
      <br />
      <div>- If there is network connection, it will display success.</div>
      <div>
        - If none, it will be queued by react native app then will be triggered
        sending once network is back online
      </div>
      <br />

      <div>Select a color</div>
      <select
        value={formVals.chosenColor}
        placeholder="Select a color"
        onChange={(event) => {
          setChosenColor(event?.target?.value ?? "");
        }}
      >
        <option value="red">Red</option>
        <option value="yellow">Yellow</option>
        <option value="blue">Blue</option>
        <option value="white">White</option>
      </select>
      <br />
      <br />
      <div>Why that color?</div>
      <input
        placeholder="Why?"
        onChange={(event) => setReason(event?.target?.value ?? "")}
      ></input>
      <br />
      <br />
      <button
        onClick={() => {
          //@ts-ignore
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              key: ActionQueueItemKey.FAKE_API_REQUEST,
              data: formVals,
            })
          );
        }}
      >
        SEND
      </button>
      <br />
    </div>
  );
};

export default ActionQueue;
